(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    const select = root.querySelector('[data-standing-season-select]');
    if (!select) return;
    root.dataset.initialized = 'true';
    const seasons = [...root.querySelectorAll('[data-standing-season]')];
    const seriesButtons = [...root.querySelectorAll('[data-standing-series]')];
    const announce = root.querySelector('[data-standing-announcement]');
    let year = root.dataset.defaultYear, series = 'supercross', classKey = null;
    const setTabs = (buttons, active) => buttons.forEach(button => {
      const selected = button === active;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    });
    function display(updateHash = false) {
      let season = seasons.find(item => item.dataset.standingSeason === year) || seasons[0];
      if (!season) return;
      year = season.dataset.standingSeason; select.value = year;
      seasons.forEach(item => { item.hidden = item !== season; });
      const panels = [...season.querySelectorAll('[data-standing-series-panel]')];
      let panel = panels.find(item => item.dataset.standingSeriesPanel === series) || panels[0];
      series = panel.dataset.standingSeriesPanel;
      panels.forEach(item => { item.hidden = item !== panel; item.setAttribute('role', 'tabpanel'); });
      setTabs(seriesButtons, seriesButtons.find(button => button.dataset.standingSeries === series));
      seriesButtons.forEach(button => button.setAttribute('aria-controls', panels.find(item => item.dataset.standingSeriesPanel === button.dataset.standingSeries).id));
      panel.setAttribute('aria-labelledby', seriesButtons.find(button => button.dataset.standingSeries === series).id);
      const classes = [...panel.querySelectorAll('[data-standing-class]')];
      const active = classes.find(button => button.dataset.standingClass === classKey) || classes[0];
      if (!active) return;
      classKey = active.dataset.standingClass;
      setTabs(classes, active);
      classes.forEach(button => button.setAttribute('aria-controls', button.hash.slice(1)));
      const nav = panel.querySelector('[data-standing-classes]'); nav.setAttribute('role','tablist');
      panel.querySelectorAll('[data-standing-championship]').forEach(item => {
        item.hidden = item.dataset.standingChampionship !== classKey;
        item.setAttribute('role','tabpanel');
        item.setAttribute('aria-labelledby', classes.find(button => button.dataset.standingClass === item.dataset.standingChampionship).id);
      });
      announce.textContent = `${year} ${active.textContent.trim()} standings`;
      if (updateHash) history.replaceState(null, '', active.hash);
    }
    function readHash() {
      const link = [...root.querySelectorAll('[data-standing-class]')].find(item => item.hash === location.hash);
      if (link) {
        year = link.closest('[data-standing-season]').dataset.standingSeason;
        series = link.closest('[data-standing-series-panel]').dataset.standingSeriesPanel;
        classKey = link.dataset.standingClass;
      }
      display();
    }
    root.querySelector('[data-standing-controls]').hidden = false;
    root.querySelectorAll('[data-standing-extra]').forEach(row => { row.hidden = true; });
    root.querySelectorAll('[data-standing-expander]').forEach(expander => { expander.hidden = false; });
    select.addEventListener('change', () => { year = select.value; display(true); });
    seriesButtons.forEach(button => button.addEventListener('click', () => { series = button.dataset.standingSeries; classKey = null; display(true); }));
    root.querySelectorAll('[data-standing-class]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); classKey = button.dataset.standingClass; display(true); }));
    root.addEventListener('keydown', event => {
      const button = event.target.closest('[role="tab"]');
      if (!button || !['ArrowLeft','ArrowRight','Home','End',' '].includes(event.key)) return;
      event.preventDefault();
      if (event.key === ' ') { button.click(); return; }
      const buttons = [...button.parentElement.querySelectorAll('[role="tab"]')];
      const index = buttons.indexOf(button);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length-1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next].focus(); buttons[next].click();
    });
    root.querySelectorAll('[data-standing-toggle]').forEach(button => button.addEventListener('click', () => {
      const panel = button.closest('[data-standing-championship]');
      const expanded = button.getAttribute('aria-expanded') !== 'true';
      const top = button.getBoundingClientRect().top;
      panel.querySelectorAll('[data-standing-extra]').forEach(row => { row.hidden = !expanded; });
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? 'Show top 20 −' : 'View full standings +';
      panel.querySelector('[data-standing-count]').textContent = `Showing ${expanded ? button.dataset.total : 20} of ${button.dataset.total} riders`;
      // Keep the collapse control at its previous viewport position and focus.
      if (!expanded) window.scrollBy(0, button.getBoundingClientRect().top - top);
      announce.textContent = expanded ? `All ${button.dataset.total} riders shown` : 'Top 20 riders shown';
    }));
    window.addEventListener('hashchange', readHash);
    readHash();
  }
  document.querySelectorAll('[data-standings-hub]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-standings-hub]').forEach(init));
})();
